export const statusColumns = [
  {
    label: 'ID',
    key: 'id',
  },
  {
    label: 'Checkin',
    key: 'checkin',
  },
  {
    label: 'Code',
    key: 'code',
  },
  {
    label: 'Competency',
    key: 'competency',
  },
  {
    label: 'Concept',
    key: 'concept',
  },
  {
    label: 'Description',
    key: 'description',
  },
  {
    label: 'Scope',
    key: 'scope',
  },
  {
    label: 'Type',
    key: 'type',
  },
];
